/**
 * Format a number as currency.
 *
 * @param {number} places number of decimals
 * @param {string} symbol currency symbol
 * @param {string} thousand thousands separator
 * @param {string} decimal decimals separator
 * @returns {string}
 */
Number.prototype.formatMoney = function (places, symbol, thousand, decimal) {
  places = !isNaN((places = Math.abs(places))) ? places : 2
  symbol = symbol !== undefined ? symbol : '$'
  thousand = thousand || ','
  decimal = decimal || '.'
  var number = this,
    negative = number < 0 ? '-' : '',
    i = parseInt((number = Math.abs(+number || 0).toFixed(places)), 10) + '',
    j = (j = i.length) > 3 ? j % 3 : 0
  return (
    symbol +
    negative +
    (j ? i.substr(0, j) + thousand : '') +
    i.substr(j).replace(/(\d{3})(?=\d)/g, '$1' + thousand) +
    (places
      ? decimal +
        Math.abs(number - i)
          .toFixed(places)
          .slice(2)
      : '')
  )
}

/**
 * Format a number as a currency string.
 *
 * @param {number} num
 * @param {number} [decimals=0]
 * @returns {string}
 */
function moneyFormat(num, decimals = 0) {
  num = num.toString()
  if (num === '') {
    num = '0.00'
  } else {
    num = parseFloat(num.replace(/[^\d\.-]/g, '')).formatMoney(decimals, '$', ',', '.')
  }
  return num
}

/**
 * Convert a currency string back to a number
 *
 * @param {string} amount
 * @returns {number}
 */
function unMoneyFormat(amount, decimals = 0) {
  return Number(amount.replace(/[^0-9.-]+/g, '')).toFixed(decimals)
}

module.exports = {
  moneyFormat,
  unMoneyFormat,
}
